import React from 'react';
import { BaseIcon } from '../../base/BaseIcon';
import { IconProps } from '../../types';

export const TsplatFallLinearIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
      strokeWidth={strokeWidth}
    >
      <path
        d="M23.82 19.43L12.82 3.42999C12.45 2.88999 11.54 2.88999 11.17 3.42999L0.179998 19.43C-0.130002 19.89 -0.0200017 20.51 0.439998 20.82C0.889998 21.13 1.52 21.02 1.83 20.56L12 5.76999L22.18 20.57C22.5 21.03 23.12 21.14 23.57 20.83C24.03 20.52 24.14 19.89 23.83 19.44L23.82 19.43Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

TsplatFallLinearIcon.displayName = 'TsplatFallLinearIcon';
